import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ef294b6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "schema-selection" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Schema Selection", -1))
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "schemaName" }, "Schema Name", -1))
const _hoisted_5 = { class: "navigation" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ($setup.selectedSchemaName = $event)),
        id: "schemaName"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.schemaNames, (schemaName) => {
          return (_openBlock(), _createElementBlock("option", { key: schemaName }, _toDisplayString(schemaName), 1))
        }), 128))
      ], 512), [
        [_vModelSelect, $setup.selectedSchemaName]
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.goBack && $setup.goBack(...args)))
      }, "Back"),
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.goNext && $setup.goNext(...args)))
      }, "Next")
    ])
  ]))
}